const TabsView = (SetDesign, $, services) => {
    $('.sd-ss-tabs').each((i, container) => {
        const $container = $(container);
        const $links = $container.find('.sd-ss-tabs__service-list__link');
        const $embedWrap = $container.find('.sd-ss-tabs__embed');
        const setAriaPressed = ($elem, value) => $elem.attr('aria-pressed', value);

        const selectTab = (e) => {
            const $target = $(e.currentTarget);
            const targetId = $target.data('targetId');
            setAriaPressed($links, false);
            setAriaPressed($target, true);
            $target.trigger('ss-select-embed', [targetId]);
        };

        const getAspectRatio = (embed) => {
            const widthMatch = embed.match(/width="(\d+(?:\.\d+)?%?)"/i);
            const heightMatch = embed.match(/height="(\d+(?:\.\d+)?%?)"/i);
            return !widthMatch
                || !heightMatch
                || widthMatch[1].endsWith('%')
                || heightMatch[1].endsWith('%')
                ? false
                : parseFloat(heightMatch[1]) / parseFloat(widthMatch[1]);
        };

        $container.on('ss-select-embed', (e, id) => {
            const embed = services[id]?.embed || '';
            const aspectRatio = getAspectRatio(embed);
            $embedWrap.css('padding-top', aspectRatio ? `${aspectRatio * 100}%` : '');
            $embedWrap.html(embed);
        });

        $links.on('click stream-selector-activate', selectTab);

        if (!$container.parents('.sd-ss-flyout').length) {
            setTimeout(() => {
                $links.first().trigger('stream-selector-activate');
            }, 0);
        }
    });
};

export default TabsView;
